/* eslint-disable import/prefer-default-export */
import {getTranslationsData as getCommonTranslationData} from '../../common/localization';
import {intlData} from './date';

export const getTranslationsData = lang => getCommonTranslationData(lang, intlData);



// WEBPACK FOOTER //
// ./utils/translation.jsx